// classnames:
// .c-readmore[--sm][-only|-down]

(function($){

    var $readmoreItems;

    function toggleReadmoreItem($item) {
        $item.toggleClass('is-opened');
    }

    function initReadmoreItems($items) {
        $items.each(function(){
            var $item = $(this);
            
            var $toggleBtn = $('<a href="#" class="c-btn-readmore">')
                .on('click', toggleReadmoreItem.bind($toggleBtn, $item))
                .insertAfter($item);

            var $veil = $('<div class="c-veil-readmore">')
                .appendTo($item);
            
            $item
                .data('toggle-btn', $toggleBtn)
                .data('veil', $veil);
        });

        updateReadmoreItems($items);
    }

    function updateReadmoreItems($items) {
        $items.each(function () {
            var $item = $(this);
            var computedStyle = window.getComputedStyle(this);
            // If the readmore is hidden, hide the button and we're done
            if (computedStyle.getPropertyValue('display') === 'none') {
                $item.data('toggle-btn').hide();
                $item.data('veil').hide();
                return;
            };

            // If the element's height is not being cut off by max-height, hide the toggle button
            var maxHeight = parseFloat(computedStyle.getPropertyValue('max-height'));
            var curHeight = $item[0].scrollHeight;
            if (isNaN(maxHeight) || maxHeight >= curHeight) {
                // Element is not cut off
                $item.data('toggle-btn').hide();
                $item.data('veil').hide();
                return;
            }

            $item.data('toggle-btn').show();
            $item.data('veil').show();
        });
    }

    Drupal.behaviors.readmore = {
        attach: function(context, settings) {
            // Add readmore elements to list, or create a list with readmore items if none exists yet
            var $items = $('[class*="c-readmore"]', context);
            if (!$readmoreItems) $readmoreItems = $items;
            else {
                $items.each(function(){
                    $readmoreItems.push(this);
                })
            }

            initReadmoreItems($items);
        }
    };

    $(window).on('resize', function(){
        updateReadmoreItems($readmoreItems);
    });

})(jQuery);
